import { normalizeAppLocale, type AppLocale } from '@/constants/locales'

const STORAGE_KEY = 'i18nextLng'

function readQueryLocale(): AppLocale | null {
  if (typeof window === 'undefined') {
    return null
  }
  const params = new URLSearchParams(window.location.search)
  const raw = params.get('lang') ?? params.get('lng')
  if (!raw) {
    return null
  }
  const normalized = normalizeAppLocale(raw)
  if (raw === 'fr' || raw === 'en' || raw.startsWith('fr') || raw.startsWith('en')) {
    return normalized
  }
  return null
}

function readStoredLocale(): AppLocale | null {
  if (typeof window === 'undefined') {
    return null
  }
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'fr' || saved === 'en') {
    return saved
  }
  return null
}

function readNavigatorLocale(): AppLocale | null {
  if (typeof navigator === 'undefined') {
    return null
  }
  const browserLang = navigator.language || (navigator as Navigator & { userLanguage?: string }).userLanguage
  if (browserLang?.toLowerCase().startsWith('fr')) {
    return 'fr'
  }
  if (browserLang?.toLowerCase().startsWith('en')) {
    return 'en'
  }
  return null
}

/**
 * Boot locale: querystring > localStorage > navigator > en
 * Persists query result to localStorage when present.
 */
export function resolveInitialLocale(): AppLocale {
  const fromQuery = readQueryLocale()
  if (fromQuery) {
    try {
      localStorage.setItem(STORAGE_KEY, fromQuery)
    } catch {
      // ignore quota / private mode
    }
    return fromQuery
  }

  const fromStorage = readStoredLocale()
  if (fromStorage) {
    return fromStorage
  }

  const fromNavigator = readNavigatorLocale()
  if (fromNavigator) {
    return fromNavigator
  }

  return 'en'
}
